<template>
  <div>
    <div class="exportTemplate flex-between">
      <div class="title-0">班主任管理工作概况</div>
      <a-row :span="80" style="width: 50%">
        <a-col :span="4">
          <j-dict-select-tag
            style="width: 100%"
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :allowClear="true"
            :isShowEmpty="false"
            @select="(record) => selectTag('grade', record)"
          />
        </a-col>
        <a-col :span="4" style="margin-left: 10px">
          <j-dict-select-tag
            style="width: 100%"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :async="true"
            :disabled="!queryParam.gradeId"
            :isShowEmpty="false"
            @select="(record) => selectTag('class', record)"
          />
        </a-col>
        <a-col :span="6" style="margin-left: 10px">
          <a-range-picker :value="rangeDate" @change="onRangeChange" />
        </a-col>
        <a-col :span="4" style="margin-left: 20px">
          <div style="display: flex">
            <a-button type="primary" @click="loadData()" icon="search">查询</a-button>
            <a-button
              type="primary"
              @click="handleExportXls(queryParam.filename)"
              style="margin-left: 10px"
            >
              导出
            </a-button>
          </div>
        </a-col>
      </a-row>
    </div>
    <a-tabs v-if="currPage === 1" :active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
        <TableList
          rowKey="teacherId"
          :columns="item.columns"
          :tableData="item.tableData"
          :pagination="item.pagination"
          :loading="item.loading"
          :scroll="{}"
          @change="handleTableChange"
        >
          <template slot="teacherlRemind" slot-scope="{ record }">
            <a-popconfirm
              title="确定要提醒吗？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="teacherRemindList(record)"
            >
              <span style="color: #1783e8; cursor: pointer">提醒</span>
            </a-popconfirm>
          </template>
        </TableList>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getDictCodeData } from '@/utils/util'
import moment from 'moment'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'ClassTeacherWork',
  mixins: [JeecgListMixin],
  components: {
    TableList,
  },
  data() {
    return {
      rangeDate: [],
      disableMixinCreated: true,
      tabKey: 1,
      currPage: 1,
      queryParam: {},
      selectedRowKeys: [],
      previewEvalData: {},
      tabPaneConfig: [
        {
          tab: '爱心小叮当提醒',
          key: 1,
          columns: [
            {
              title: '排名',
              dataIndex: 'index',
              align: 'center',
              width: 60,
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
            },
            {
              title: '教师姓名',
              dataIndex: 'teacherName',
              align: 'center',
            },
            {
              title: '访问次数',
              dataIndex: 'visitCnt',
              align: 'center',

              // sorter: (a, b) => a.warn - b.warn,
            },
            {
              title: '未处理提醒',
              dataIndex: 'unDealWarnCnt',
              align: 'center',

              // sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
            },
            {
              title: '已处理提醒',
              dataIndex: 'dealWarnCnt',
              align: 'center',

              // sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
            },
            {
              title: '操作',
              dataIndex: 'teacherlRemind',
              scopedSlots: { customRender: 'teacherlRemind' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
        {
          tab: '心理健康测评',
          key: 2,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '心理测评名称',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
            },
            {
              title: '教师姓名',
              dataIndex: 'classTeacherName',
              align: 'center',
            },
            {
              title: '未完成学生',
              // dataIndex: 'createBy',
              align: 'center',
              customRender: (_, record) => {
                return record.planStudentNum - record.finishStudentNum
              },
            },
            {
              title: '已完成学生',
              dataIndex: 'finishStudentNum',
              align: 'center',
            },
            // {
            //   title: '操作',
            //   dataIndex: 'action',
            //   align: 'center',
            //   scopedSlots: { customRender: 'action' },
            // },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '',
      },
    }
  },
  created() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    console.log(this.queryParam.beginDate)
    console.log(this.queryParam.endDate)
    this.loadData()
  },
  methods: {
    selectTag(type, record) {
      console.log('选择标签', record, type)
      switch (type) {
        case 'grade':
          this.$set(this.queryParam, 'classId', '')
          this.$set(this.queryParam, 'gradeId', record.value)
          this.currGradeName = record.text
          break
        case 'class':
          this.$set(this.queryParam, 'classId', record.value)
          this.currClassName = record.text
          break
      }
      // this.$set(this.formData, 'name', record.text)
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      if (!dateString[0] && !dateString[1]) {
        this.$notification['success']({
          message: '通知',
          description: '请选择时间范围',
        })
        return
      }

      this.rangeType = 'range'
      this.rangeDate = dates
      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
      console.log(this.queryParam)
    },
    getDictCodeData(status) {
      return getDictCodeData('assessment_status', status).text || ''
    },
    handleTabChange(key) {
      this.tabKey = key
      var beginDate = this.queryParam.beginDate
      var endDate = this.queryParam.endDate
      this.queryParam = {}
      this.queryParam.beginDate = beginDate
      this.queryParam.endDate = endDate
      this.loadData()
    },
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    teacherRemindList(record) {
      const customText =
        record.teacherName +
        '老师您好，您收到一条来自后台' +
        '的提醒消息，本周您还有' +
        record.unDealWarnCnt +
        '条提醒未处理，请及时跟进处理。'

      const requestData = {
        teacherId: record.teacherId,
        text: customText,
      }
      //催办班主任提醒处理
      getAction('/aigoes/schoolClass/earlyWarning', requestData).then((res) => {
        console.log(res)
        if (res.success) {
          // this.$message.success('催办成功！');
          this.$notification['success']({
            message: '通知',
            description: '已提醒班主任！',
          })
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    loadData() {
      let params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
      }
      switch (this.tabKey) {
        case 1:
          this.queryParam.filename = '爱心小叮当提醒导出'
          this.queryParam.planId = undefined
          this.$set(this.url, 'list', '/statistic/teacherSituation')
          this.$set(this.url, 'exportXlsUrl', '/statistic/teacherSituationExport')
          params = {
            ...params,
            beginDate: this.queryParam.beginDate,
            endDate: this.queryParam.endDate,
          }
          break
        case 2:
          this.queryParam.filename = '心理健康测评提醒导出'
          this.queryParam.planId = ''
          this.$set(this.url, 'list', '/schoolEvaluationPlan/classCompletionProgress')
          this.$set(this.url, 'exportXlsUrl', '/schoolEvaluationPlan/classCompletionProgressExport')
          params = {
            ...params,
            planId: '',
            beginDate: this.queryParam.beginDate,
            endDate: this.queryParam.endDate,
          }
          break
      }
      this.getTableData(params)
    },
    getTableData(params) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            let tableData = []
            if (this.tabKey === 1) {
              tableData = res.result?.length
                ? res.result.map((item, index) => ({
                    ...item,
                    index: index + 1,
                  }))
                : []
            } else {
              tableData = res.result.records?.length
                ? res.result.records.map((item, index) => ({
                    ...item,
                    index: index + 1,
                  }))
                : []
            }
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            console.log('列表数据：', tableData)
            this.$set(
              this.tabPaneConfig[this.tabKey - 1].pagination,
              'total',
              res.result.total || res.result.length
            )
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
  },
}
</script>
<style scoped lang="less">
.action-detail {
  color: #0077fa !important;
  cursor: pointer !important;
  .forbidden {
    pointer-events: none;
    cursor: default;
    color: #8bc1f3;
  }
}
.exportTemplate {
  align-items: center;
}
</style>
